var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex align-center os-password-information-item"},[(_vm.valid)?_c('div',{staticClass:"mdi mdi-lock-outline os-icon",staticStyle:{"color":"#25c864"}}):_c('div',{staticClass:"mdi mdi-circle-small os-icon",staticStyle:{"color":"#464646"}}),_c('div',{staticClass:"body-2"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }